import { Calendar } from "lucide-react";
import { useState } from "react";
import { useEffect } from "react";
import { authFetch } from "../../../api";

export default function DashboardTasks() {
  const userId = localStorage.getItem("userId");
  const [upcomingTasks, setUpcomingTasks] = useState([]);
  const fetchUpcomingTasks = async () => {
    try {
      const response = await authFetch("timeline/show-upcoming-tasks", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ user_id: userId }),
      });

      const res = await response.json();

      if (res.success) {
        setUpcomingTasks(res.data || []);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchUpcomingTasks();
  }, []);
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
      {/* ================= Upcoming Task ================= */}
      <div className="bg-white rounded-xl p-4 shadow-sm">
        <h3 className="text-lg font-bold text-[#222222] font-inter mb-4">
          Upcoming Task
        </h3>

        <div className="space-y-3 max-h-[160px] overflow-y-auto pr-2 scrollbar-hide">
          {upcomingTasks.length === 0 ? (
            <p className="text-sm text-gray-500">No upcoming tasks</p>
          ) : (
            upcomingTasks.map((task, index) => {
              const date = new Date(task.created_at);
              const formattedDate = date.toLocaleDateString("en-IN", {
                day: "numeric",
                month: "short",
              });

              const formattedTime = date.toLocaleTimeString("en-IN", {
                hour: "2-digit",
                minute: "2-digit",
              });

              return (
                <div
                  key={index}
                  className="flex items-center justify-between rounded-lg border border-purple-100 p-3 bg-gradient-to-l from-purple-50 to-white"
                >
                  <div className="flex items-start gap-3">
                    <div className="w-9 h-9 rounded-lg bg-purple-100 flex items-center justify-center">
                      <img src="/brain.png" alt="icon" />
                    </div>

                    <div>
                      <p className="text-sm font-inter font-semibold text-[#572575]">
                        {task.task_title}
                      </p>

                      <div className="flex items-center gap-1 text-xs text-gray-700 font-inter mt-1">
                        <Calendar className="w-3 h-3" />
                        {formattedTime} | {formattedDate}
                      </div>
                    </div>
                  </div>

                  <span className="text-xs font-inter font-medium text-orange-600 bg-orange-50 px-2 py-1 rounded-md">
                    {task.task_status === 0 ? "Pending" : "Completed"}
                  </span>
                </div>
              );
            })
          )}
        </div>
      </div>

      {/* ================= University Application ================= */}
      <div className="bg-white rounded-xl p-4 shadow-sm ">
        <h3 className="text-lg font-bold text-[#222222] font-inter mb-4">
          University Application
        </h3>

        <div className="rounded-lg border border-purple-100 p-4 bg-gradient-to-l from-purple-50 to-white">
          <div className="flex items-start justify-between mb-3">
            <p className="text-sm font-inter font-semibold text-[#572575]">
              Diploma in Social Work
            </p>

            <span className="text-xs font-inter font-medium text-green-600 bg-green-50 px-2 py-1 rounded-md">
              Offer Received
            </span>
          </div>

          <div className="flex items-center gap-2 text-sm text-[#222222] font-inter font-semibold mb-3">
            <img src="/loc.png" alt="loc" className="h-10 w-10" />
            Bow Valley College, Canada
          </div>

          <span className="inline-block text-xs font-medium bg-yellow-100 text-black px-3 py-1 rounded-full font-inter">
            Intake : May to June
          </span>
        </div>
      </div>
    </div>
  );
}
